<template>
  <v-card class="left-vertical-card">
    <div class="d-flex bg-titre">
      <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
        {{ redirection.titre }}
      </div>
      <v-btn
        class="align-self-center"
        text
        @click="onClose"
      >
        <v-icon color="secondary">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <div class="d-flex justify-space-between ma-5">
      <v-chip
        v-if="isActif"
        class="align-self-center"
        color="secondary"
        outlined
      >
        <div class="texte secondary--text">
          Actif
        </div>
      </v-chip>
      <v-chip
        v-else
        class="align-self-center"
        color="#EC6608"
        outlined
      >
        <div class="texte orange-text">
          Inactif
        </div>
      </v-chip>
      <v-chip
        v-if="redirection.nouveaute"
        class="align-self-center"
        color="#DBBD00"
        label
      >
        <div class="texte white--text">
          Nouveau
        </div>
      </v-chip>
    </div>
    <v-divider class="my-3 mx-5" />
    <div class="intro d-flex secondary--text ml-5">
      Texte
    </div>
    <div class="texte texte-gris-fonce d-flex ml-5 mt-2">
      {{ redirection.texte }}
    </div>
    <v-divider class="my-3  mx-5" />
    <div class="d-flex justify-space-between mx-5">
      <div class="intro align-self-start secondary--text">
        Pages origine
      </div>
      <div class="align-self-start">
        <div
          v-for="page in redirection.pagesOrigines"
          :key="page.id"
          class="texte texte-gris-fonce"
        >
          {{ page.libelle }}
        </div>
      </div>
    </div>
    <v-divider class="my-3 mx-5" />
    <div class="d-flex justify-space-between mx-5">
      <div class="intro secondary--text">
        Page destination
      </div>
      <div class="texte texte-gris-fonce">
        {{ redirection.pageDestination.libelle }}
      </div>
    </div>
    <v-divider class="my-3 mx-5" />
    <div class="d-flex justify-space-between mx-5">
      <div class="intro secondary--text">
        Public visé
      </div>
      <div class="texte texte-gris-fonce">
        {{ libellePublicVise }}
      </div>
    </div>
    <v-divider class="my-3 mx-5" />
    <div class="d-flex justify-space-between mx-5">
      <div class="intro secondary--text">
        Date début
      </div>
      <div class="texte texte-gris-fonce">
        {{ redirection.dateDebut | date('dd/MM/yyyy') }}
      </div>
    </div>
    <div class="d-flex justify-space-between mx-5">
      <div class="intro secondary--text">
        Date fin
      </div>
      <div
        v-if="redirection.dateFin"
        class="texte texte-gris-fonce"
      >
        {{ redirection.dateFin | date('dd/MM/yyyy') }}
      </div>
      <div
        v-else
        class="texte texte-gris-fonce"
      >
        -
      </div>
    </div>
    <v-divider
      v-if="redirection.pictogramme"
      class="my-3 mx-5"
    />
    <div
      v-if="redirection.pictogramme"
      class="d-flex justify-space-between mx-5"
    >
      <div class="intro secondary--text">
        Pictogramme
      </div>
      <div class="picto">
        <v-img
          :src="picto(redirection.pictogramme.path)"
        />
      </div>
    </div>
    <div class="d-flex mt-5 mx-5">
      <AgrButton
        block
        class="pa-5"
        @click="onClose"
      >
        Fermer
      </AgrButton>
    </div>
  </v-card>
</template>

<script>
import {AgrButton} from '@agrial/ui'
import { addDays, isAfter, isWithinInterval, parse } from 'date-fns'

export default {
  name: 'DetailRebondModal',
  components: {AgrButton},
  props: {
    redirection: {
      type: Object,
      default: null
    },
  },
  computed: {
    isActif () {
      if (this.redirection.dateFin != null) {
        return isWithinInterval(new Date(), {
          start: parse(this.redirection.dateDebut, 'yyyy-MM-dd', new Date()),
          end: addDays(parse(this.redirection.dateFin, 'yyyy-MM-dd', new Date()), 1),
        })
      } else {
        return isAfter(new Date(), parse(this.redirection.dateDebut, 'yyyy-MM-dd', new Date()))
      }
    },
    libellePublicVise () {
      return this.redirection.cible.libelle
    }
},
  methods: {
    onClose () {
      this.$emit('close')
    },
    picto (path) {
      return '/images/pictogrammes/' + path + '.svg'
    }

  }
}
</script>

<style lang="scss" scoped>
.logo {
  width: 5rem;
}
.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}
.orange-text {
  color: #EC6608;
}

</style>
